const STORAGE_KEY = 'cgTfaTrustTokens'

function readStore () {
  if (typeof window === 'undefined') { return {} }
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY)
    if (!raw) { return {} }
    const parsed = JSON.parse(raw)
    return parsed && typeof parsed === 'object' ? parsed : {}
  } catch {
    return {}
  }
}

function writeStore (store) {
  if (typeof window === 'undefined') { return }
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(store))
  } catch {
    // storage full / disabled — ignore
  }
}

function normalizeEmail (email) {
  return email.trim().toLowerCase()
}

export function getTrustTokenFor (email) {
  if (!email) { return null }
  const store = readStore()
  const entry = store[normalizeEmail(email)]
  if (!entry) { return null }
  if (new Date(entry.expiresAt).getTime() <= Date.now()) {
    delete store[normalizeEmail(email)]
    writeStore(store)
    return null
  }
  return entry.token
}

export function saveTrustToken (email, token, expiresAt) {
  if (!email || !token || !expiresAt) { return }
  const store = readStore()
  store[normalizeEmail(email)] = { token, expiresAt }
  writeStore(store)
}

export function removeTrustTokenFor (email) {
  if (!email) { return }
  const store = readStore()
  if (store[normalizeEmail(email)]) {
    delete store[normalizeEmail(email)]
    writeStore(store)
  }
}

export function removeAllTrustTokens () {
  if (typeof window === 'undefined') { return }
  try {
    window.localStorage.removeItem(STORAGE_KEY)
  } catch {
    // ignore
  }
}
